import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  ILineaResponse, 
  ILineaRequest,
  ILineaSaveRequest,
  ILineaSaveResponse,
  ILineaDeleteRequest,
  ILineaDeleteResponse,
  ITipoOpcionRequest,
  ITipoOpcionResponse
} from '../interfaces/linea.interface';

@Injectable({
  providedIn: 'root'
})
export class LineaService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Articulos/cmspa_lineas`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}GetMnto/GetLinsErr`;
  private readonly API_URL_TIPOS = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetOpcionesVariables`;

  constructor(private http: HttpClient) { }

  getLineas(request: ILineaRequest): Observable<ILineaResponse> {
    return this.http.post<ILineaResponse>(this.API_URL, request);
  }

  getLineasDefault(): Observable<ILineaResponse> {
    const payload: ILineaRequest = {
      cmd: "",
      contrato: "",
      descripcion: "",
      identificacion: "",
      monto: "",
      numeroLinea: "",
      otraDescripcion: "",
      score: 0,
      telefono: "",
      tipo: "",
      tope: "9999"
    };
    return this.http.post<ILineaResponse>(this.API_URL, payload);
  }

  saveLinea(payload: ILineaSaveRequest): Observable<ILineaSaveResponse> {
    return this.http.post<ILineaSaveResponse>(this.API_URL_SAVE, payload);
  }

  createLinea(numeroLinea: string, descripcion: string, tipo: string): Observable<ILineaSaveResponse> {
    const payload: ILineaSaveRequest = {
      que: 1,
      numero_linea: numeroLinea,
      descripcion: descripcion,
      tipo: tipo,
      contrato: "",
      otra_descripcion: "",
      identificacion: "",
      monto: "",
      telefono: "",
      score: 0
    };
    return this.http.post<ILineaSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateLinea(numeroLinea: string, descripcion: string, tipo: string): Observable<ILineaSaveResponse> {
    const payload: ILineaSaveRequest = {
      que: 2,
      numero_linea: numeroLinea,
      descripcion: descripcion,
      tipo: tipo,
      contrato: "",
      otra_descripcion: "",
      identificacion: "",
      monto: "",
      telefono: "",
      score: 0
    };
    return this.http.post<ILineaSaveResponse>(this.API_URL_SAVE, payload);
  }

  deleteLinea(numeroLinea: string): Observable<ILineaDeleteResponse> {
    const payload: ILineaDeleteRequest = {
      que: 3,
      numero_linea: numeroLinea,
      descripcion: "",
      tipo: "",
      contrato: "",
      otra_descripcion: "",
      identificacion: "",
      monto: "",
      telefono: "",
      score: 0
    };
    return this.http.post<ILineaDeleteResponse>(this.API_URL_SAVE, payload);
  }

  getTiposOpciones(): Observable<ITipoOpcionResponse> {
    const payload: ITipoOpcionRequest = {
      sTabla: "lineas",
      sCampo: "tipo",
      iIdioma: 0
    };
    return this.http.post<ITipoOpcionResponse>(this.API_URL_TIPOS, payload);
  }
} 